/* @flow */
import React, { useContext, memo } from 'react'
import S from './Feature30.styled'
import { validation } from './Feature30.consts'
import ActionGetter from './Actions'
import Mapper from '@website/common/components/Mapper'
import AddButton from '@website/common/components/AddButton'
import Icon from '@website/common/components/Icon'
import { DispatchContext, EditingContext } from '@contexts'
import EditableContent from '@website/common/components/EditableContent'
import { ControlsWithModalOpener } from '@website/common/components/Controlled'
import AdditionalLink from '@website/common/components/AdditionalLink/AdditionalLink'
import { translate } from '@editor/common/utils/translations'

const Feature30 = memo(props => {
  const {
    data: {
      featureParts,
      backgroundImgDimensions,
      backgroundImgUrl,
      bgOverlayTransparency
    }
  } = props

  const dispatcher = useContext(DispatchContext)
  const { isEditing } = useContext(EditingContext)
  const Actions = ActionGetter(dispatcher)

  return (
    <S.StyledContainer
      isEditing={isEditing}
      backgroundImgUrl={backgroundImgUrl}
      backgroundImgDimensions={backgroundImgDimensions}
      bgOverlayTransparency={bgOverlayTransparency}
    >
      <S.WMCustomContainer>
        <S.BlocksWrap
          blockCount={featureParts.length}
          isFourBlock={featureParts.length === 4}
        >
          <Mapper
            data={featureParts}
            render={(featureBlock, idx) => (
              <S.BlockItemWrap key={idx}>
                <ControlsWithModalOpener
                  actions={Actions.featureActions({
                    idx,
                    showRemove:
                      featureParts.length !== validation.featureParts.min
                  })}
                  style={{ alignItems: 'center' }}
                >
                  <S.FiguresWrapper
                    className="figures-wrapper"
                    isEditing={isEditing}
                  >
                    <S.Figure className="figure1" />
                    <S.Figure className="figure2" />
                    <S.Figure className="figure3" />
                    <S.Figure className="figure4" />
                  </S.FiguresWrapper>
                  <EditableContent
                    text={featureBlock.blockTitle}
                    as={S.Title}
                    required={!featureBlock.blockDescription}
                    maxCount={validation.blockTitleMaxChar}
                    onChange={(newTitle: string) =>
                      Actions.changeBlockTitle(newTitle, idx)
                    }
                    className="WM_GLOBAL_heading24"
                    alignment={featureBlock.titleAlignment}
                    changeAlignment={Actions.changeTitleAlignment(idx)}
                  />
                  <EditableContent
                    text={featureBlock.blockDescription}
                    as={S.Description}
                    required={!featureBlock.blockTitle}
                    maxCount={validation.blockParagraphMaxChar}
                    onChange={(newDescription: string) =>
                      Actions.changeBlockContent(idx, newDescription)
                    }
                    className="WM_GLOBAL_paragraph18"
                    alignment={featureBlock.paragraphAlignment}
                    changeAlignment={Actions.changeParagraphAlignment(idx)}
                  />
                  <AdditionalLink
                    idx={idx}
                    additionalLinkText={featureBlock.additionalText}
                    additionalLinkUrl={featureBlock.additionalUrl}
                  />
                </ControlsWithModalOpener>
              </S.BlockItemWrap>
            )}
          />
        </S.BlocksWrap>
        <AddButton
          style={{ marginTop: '2rem' }}
          onAdd={Actions.addBlock}
          toShow={featureParts.length < validation.featureParts.max}
        >
          <Icon name="glyph-add" className="icon" size="normal" />
          {translate('add_block_label')}
        </AddButton>
      </S.WMCustomContainer>
    </S.StyledContainer>
  )
})

export default Feature30
